import {styled} from "styled-components";
import {Card, Flex, Tag} from "antd";

export const StyledCard = styled(Card)`
  position: sticky;
  top: 0;
  z-index: 999;
width: 100%;
  border: none;
  box-shadow: 0px 18px 20px -31px rgba(0,0,0,0.45);
.ant-card-body{
  padding: 24px 0px;

}  
  
`;
export const StyledFlex = styled(Flex)`
    overflow-x: auto;
    scrollbar-color: transparent transparent
`;
export const StyledTag = styled(Tag)`
    border-radius: 6px;
    border: 1px solid var(--primaryColor);
    background-color: var(--primaryColor);
    color:white;
    .ant-tag-close-icon{
        color:white;
    }
`;